import {makeFilterTopic} from "./filter-topic";
import {makeObserver} from "../../topic/topic";
import Fuse from "fuse.js";
import {highlightSearchResult} from "../search-watchtower-titles/search-watchtower-titles";
import * as fuzzer from "fuzzysort"

export default function (magazines, setSearchResult) {
    /**
     * Filter magazines by years.
     * If filter has no years set then all magazines are returned.
     * @param {number[]} years
     * @returns {{number: number, month: string, year: number, title: string}[]}
     */
    function filterYears(years) {
        return years.length === 0
            ? magazines
            : magazines.filter(magazine => years.indexOf(magazine.year) > -1);
    }

    /**
     * Creates a search object for given magazines.
     * @param {{number: number, month: string, year: number, title: string}[]} magazines
     * @returns {Fuse<unknown>}
     */
    function makeSearchObject(magazines) {
        return new Fuse(magazines, {
            includeScore: true,
            includeMatches: true,
            minMatchCharLength: 3,
            findAllMatches: false,
            isCaseSensitive: false,
            shouldSort: true,
            threshold: 0.8,
            distance: 1000,
            keys: ['title']
        });
    }

    function addKeywordsToDomThatArePresentInFilter(keywords) {
        for (let i in keywords) {
            if (document.querySelector(`[data-keyword="${keywords[i]}"]`) === null) {
                document.querySelector('.horizontal-btn-group').innerHTML = document.querySelector('.horizontal-btn-group').innerHTML + `<a class="f-button btn-ghost keyword selected" data-keyword="${keywords[i]}" href="https://demo1.com">${keywords[i]}</a>`
            }
        }
    }

    /**
     * Applies keyword filter. If no keywords are set in filter will return the given magazines.
     * @param {string[]} keywords
     * @param {Fuse<unknown>} fuse
     * @returns {{"highlighted-title": string, title: string, month: string, year: string, number: string, score: number}[]}
     */
    function filterByKeywords(keywords, fuse) {
        const results = fuse.search(keywords.join(' '), {limit: 20});
        const simpleResults = results.map(r => ({item: r.item, indices: r.matches[0].indices, score: r.score}))
        const highlighted = highlightSearchResult(simpleResults)
        return highlighted.map(h => ({...h.item, score: h.score}))
    }

    function searchByTitle(keywords, objects) {
        let combinedResults = []
        for (let i in keywords) {
            const results = fuzzer.go(keywords[i]   , objects, {
                limit: 20,
                allowTypo: true,
                threshold: -10000,
                key: "title"
             })
            const highlightedResults = results.map(r => {
                const highlighted = fuzzer.highlight(r, "<h>", "</h>")
                r.obj["highlighted-title"] = highlighted
                return r
            })
            for (let i in highlightedResults) {
                const key = highlightedResults[i].obj.year + highlightedResults[i].obj.title
                if (!combinedResults[key] || (combinedResults[key] && combinedResults[key].score < highlightedResults[i].score)) {
                    combinedResults[key] = highlightedResults[i]
                }
            }
        }

        let cr = []
        for (const i in combinedResults) {
            cr.push(combinedResults[i])
        }

        return cr.map(c => ({...c.obj, score: c.score}))
    }

    const filterTopicObserver = makeObserver((subject) => {
        const {years, keywords} = subject.getState()
        const magazinesByYears = filterYears(years);
        const fuse = makeSearchObject(magazinesByYears);
        const results = keywords.length === 0 ? magazinesByYears : searchByTitle(keywords, magazinesByYears)  ;

        setSearchResult(results)
    })

    const keywordsAddObserver = makeObserver((subject) => {
        const {keywords} = subject.getState()
        addKeywordsToDomThatArePresentInFilter(keywords);
    })

    return makeFilterTopic([filterTopicObserver, keywordsAddObserver])
}